<template>
  <c-box
    :display="{ base: 'none', md: 'block' }"
    bg="white"
    mt="4xl"
    mb="-45px"
    mx="-45px"
    px="45px"
    py="3xl"
  >
    <c-heading as="h2" size="lg" mb="lg">
      {{ $t("productReturnV2.details.submitterDetails") }}
    </c-heading>
    <c-flex>
      <c-box py="md" pr="md">
        <c-text>{{ contactDetails.fullName }}</c-text>
        <c-text>{{ contactDetails.emailAddress }}</c-text>
        <c-text>{{ contactDetails.phoneNumber }}</c-text>
      </c-box>
      <c-box p="md">
        <c-text>{{ contactDetails.partnerName }}</c-text>
        <c-text>{{ contactDetails.partnerAddress1 }}</c-text>
        <c-text>{{ contactDetails.partnerAddress2 }}</c-text>
        <c-text v-if="contactDetails.partnerAddress3">
          {{ contactDetails.partnerAddress3 }}
        </c-text>
        <c-text>
          {{ contactDetails.partnerZipCode }},
          {{ contactDetails.partnerCity }}
        </c-text>
        <c-text v-if="contactDetails.partnerStateProvinceCode">
          {{
            getProvinceName(contactDetails.partnerCountry, contactDetails.partnerStateProvinceCode)
          }}
        </c-text>
        <c-text>{{ getCountryName(contactDetails.partnerCountry) }}</c-text>
      </c-box>
    </c-flex>
  </c-box>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { CBox, CFlex, CHeading, CText } from "@chakra-ui/vue";
import { getCountry, getCountrySubdivision } from "@iloq/shared";

export default defineComponent({
  name: "SubmitterDetails",
  components: {
    CBox,
    CText,
    CFlex,
    CHeading,
  },
  props: {
    contactDetails: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getProvinceName: function (countryCode: string, stateProvinceCode: string) {
      return getCountrySubdivision(countryCode, stateProvinceCode);
    },
    getCountryName: function (countryCode: string) {
      return getCountry(countryCode);
    },
  },
});
</script>
